import React from "react";
import PropTypes from "prop-types";
import InfiniteScroll from "react-infinite-scroll-component";
import { debounce } from "lodash-es";

import LoadingIndicator from "../LoadingIndicator";
import Input from "components/Form/Controls/Input";
import { search } from "domain/Users/api";
import AddPlayerInterfaceUserItem from "components/AddPlayerInterface/Item";
import Icon from "components/Icon";

import AnimatedModal from "components/Modal/AnimatedModal";

class AddPlayerInterface extends React.Component {
    state = {
        query: "",
        usersList: [],
        selectedItemId: null,
        page: 1,
        count: null,
        isLoading: false,
    };

    componentDidMount() {
        document.addEventListener("keyup", this.scrollTop);
    }

    scrollTop = (e) => {
        if (e.code === "Backspace" || e.code === "Delete") {
            document
                .querySelector(".infinite-scroll-component")
                .scrollTo({ top: 0, behavior: "smooth" });
            this.setState({ page: 1 });
        }
    };

    componentDidUpdate(prevProps) {
        if (
            prevProps.selectedUsers.length !== this.props.selectedUsers.length
        ) {
            this.setState(({ usersList }) => ({
                usersList: this.checkParticipate(usersList),
            }));
        }
    }

    checkParticipate = (candidates) =>
        candidates.map((candidate) => ({
            ...candidate,
            is_participate:
                this.props.selectedUsers.findIndex(
                    ({ id }) => id === candidate.id
                ) !== -1,
        }));

    updateList = debounce(async (query) => {
        const { searchUserMethod } = this.props;

        const response = await searchUserMethod({ query });
        const usersList = this.checkParticipate(response?.items);
        const count = response.count;
        this.setState({ usersList, count });
    }, 500);

    onSelect = async (user) => {
        const { onClose, multiple, renderSelectInterface } = this.props;
        if (this.state.isLoading) {
            return;
        }

        if (renderSelectInterface) {
            this.setState({ selectedItemId: user.id });
            return null;
        }

        this.props.onSelect(user);

        if (!multiple) {
            onClose();
        }
    };

    changeQuery = (event) => {
        const query = event.target.value;
        this.setState({ query, selectedItemId: null });

        if (query.length === 1) {
            return;
        }

        this.updateList(query);
    };

    loadMore = () => {
        this.setState({ isLoading: true });
        this.loadMorePlayers();
    };

    loadMorePlayers = async () => {
        const { searchUserMethod } = this.props;
        const { query, page } = this.state;

        if (query?.length === 1) {
            return;
        }

        const response = await searchUserMethod({ query, page: page + 1 });

        const usersList = this.checkParticipate(response.items);
        const count = response.count;
        this.setState({
            usersList: [...this.state.usersList, ...usersList],
            count,
            page: page + 1,
            isLoading: false,
        });
    };

    clearQuery = () => {
        this.setState({
            query: "",
            usersList: [],
            selectedItemId: null,
            page: 1,
            count: null,
        });
    };

    render() {
        const {
            visible,
            onClose,
            children,
            renderSelectInterface,
            hideItemControls,
            renderAdditionalInItem,
            emptyResult,
        } = this.props;
        const { query, usersList, selectedItemId, page, count } = this.state;

        if (!visible) {
            return null;
        }

        const selectedPlayer = usersList.find(
            ({ id }) => id === selectedItemId
        );

        const userCollection = selectedPlayer ? [selectedPlayer] : usersList;

        const hasMore = query.length === 1 ? false : 20 * page < count;

        return (
            <AnimatedModal
                onClose={onClose}
                title=""
                closeOnOverlay
                visible
                modificators={[`players-search`]}
            >
                {() => (
                    <>
                        <div className="players-list-input">
                            <Input
                                type="text"
                                value={query}
                                onChange={this.changeQuery}
                                label={this.props.inputLabel}
                                icon="search"
                                defaultValue={query}
                            >
                                <button
                                    type="button"
                                    className="form-input__clear form-input__clear--modal "
                                    onClick={this.clearQuery}
                                >
                                    <Icon type="backspace" InheritColor />
                                </button>
                            </Input>
                        </div>
                        {!query?.length && children ? (
                            children
                        ) : (
                            <div className="players-list players-list--modal">
                                {userCollection?.length > 0 || !emptyResult ? (
                                    <InfiniteScroll
                                        height={selectedItemId ? 115 : 415}
                                        dataLength={userCollection?.length}
                                        hasMore={hasMore}
                                        next={this.loadMore}
                                        hasChildren={false}
                                        loader={<LoadingIndicator />}
                                    >
                                        {" "}
                                        {userCollection.map((player) => (
                                            <AddPlayerInterfaceUserItem
                                                key={`AddPlayerInterfaceUserItem-${player.id}`}
                                                addPlayer={this.onSelect}
                                                player={player}
                                                selectButtonText={
                                                    this.props.selectButtonText
                                                }
                                                successText={
                                                    this.props.successText
                                                }
                                                hideControl={!!selectedPlayer}
                                                addOnItemClick={
                                                    hideItemControls
                                                }
                                                renderAdditional={
                                                    renderAdditionalInItem
                                                }
                                                trainers={this.props.trainers}
                                            />
                                        ))}
                                    </InfiniteScroll>
                                ) : (
                                    emptyResult
                                )}
                            </div>
                        )}

                        {selectedPlayer && renderSelectInterface && (
                            <div className="players-list__select-interface">
                                {renderSelectInterface({
                                    player: selectedPlayer,
                                })}
                            </div>
                        )}
                    </>
                )}
            </AnimatedModal>
        );
    }
}

AddPlayerInterface.defaultProps = {
    visible: true,
    selectedUsers: [],
    inputLabel: "Поиск игроков",
    searchUserMethod: search,
    EmptyResult: null,
};

AddPlayerInterface.propTypes = {
    visible: PropTypes.bool,
    multiple: PropTypes.bool,
    hideItemControls: PropTypes.bool,
    onSelect: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    selectedUsers: PropTypes.arrayOf(PropTypes.object),
    inputLabel: PropTypes.string,
    selectButtonText: PropTypes.string,
    successText: PropTypes.string,
    children: PropTypes.any,
    searchUserMethod: PropTypes.func,
    renderSelectInterface: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.node,
    ]),
    renderAdditionalInItem: PropTypes.func,
    emptyResult: PropTypes.any,
    trainers: PropTypes.array,
};

export default AddPlayerInterface;
